/*
 * Componente de resultados vacios del tracking: Muestra un mensaje de alerta cuando no hay declarantes creados o cuando no se encontraron
 * resultados en la busqueda o la consulta aplicada a los datos
 */

import { Button, Description, TableEmpty } from "codekit";

const Trackemp = ({ trackingEmptySettings }) => {
  return (
    <TableEmpty>
      <Description variant="description-3">{trackingEmptySettings.description}</Description>
      {trackingEmptySettings.showButton && (
        <Button variant="primary-bold" size="m" icon="circle-plus" onClick={trackingEmptySettings.handleButtonClick}>
          {trackingEmptySettings.buttonDescription}
        </Button>
      )}
    </TableEmpty>
  );
};

export default Trackemp;
